import React from 'react';
import { useDisclosure } from '@mantine/hooks';
import { Modal } from '@mantine/core';
import './DemoModal.scss';

export const DemoModal = () => {
    const [opened, { open, close }] = useDisclosure(true);
    
    return (
        <div className="demo-modal">
            <Modal opened={opened} onClose={close} title="Demo Output" centered size={1100}>
                <p>you can check the GitHub demo folder for more examples! <a href="https://github.com/Teu2/Image-Reader/tree/main/demos/demo%20output">Link</a></p>
                <img src="https://github.com/Teu2/Image-Reader/blob/main/demos/demo%20output/Demo%20(3).png?raw=true" alt="yett" />
            </Modal>
        </div>
    );
}
